import { configureStore } from "@reduxjs/toolkit";
import reducer from "./reducer";

export default function configureStoreFunction() {
  return configureStore({
    reducer,
  });
}
